import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import {
  LiliButton,
  LiliDropdown,
  LiliDropdownItem,
} from '@lili/lili-frontend-common';
import ChangeNaicsHeader from './ChangeNaicsHeader';
import { Industry } from './logic/useChangeNaicsHook';

export interface ChangeNaicsProps {
    industryList: Industry[],
    onIndustriesChanged: (industry: string, subIndustry: string) => void;
    errorMessage: string | undefined;
    isLoading: boolean;
    onSubmit: () => void;
    isValid: boolean;
}

export const ChangeNaicsForm = ({
  industryList,
  onIndustriesChanged,
  errorMessage,
  isLoading,
  onSubmit,
  isValid,
}: ChangeNaicsProps) => {
  const { t } = useTranslation();
  const [selectedIndustry, setSelectedIndustry] = useState<Industry | undefined>(undefined);
  const [selectedSubIndustry, setSelectedSubIndustry] = useState<LiliDropdownItem | undefined>(undefined);

  const handleIndustryChange = (industry: Industry) => {
    setSelectedIndustry(industry);
    setSelectedSubIndustry(undefined); // Reset sub-industry selection
  };

  const handleSubIndustryChange = (subIndustry: LiliDropdownItem) => {
    setSelectedSubIndustry(subIndustry);
    if (selectedIndustry) {
      onIndustriesChanged(selectedIndustry.industry, subIndustry.value);
    }
  };

  return (
    <div className='flex flex-col bg-bw01 rounded-[12px] height-[460px] animate-fadeIn px-[32px] pt-[32px] pb-[32px] w-[504px] '>
      <ChangeNaicsHeader />
      <LiliDropdown
        className='pb-[26px]'
        items={industryList?.map((item) => ({ title: item.industry, value: item }))}
        title={t('CHANGE_NAICS.INDUSTRY')}
        value={{ title: selectedIndustry?.industry || '', value: selectedIndustry || '' }}
        onSelect={(item) => handleIndustryChange(item.value as Industry)}
      />
      <LiliDropdown
        className='pb-[32px]'
        title={t('CHANGE_NAICS.SUB_INDUSTRY')}
        items={selectedIndustry?.subIndustryList?.map(subIndustry => ({ title: subIndustry, value: subIndustry })) || []}
        value={selectedSubIndustry}
        disabled={!selectedIndustry}
        onSelect={handleSubIndustryChange}
        errorMessage={errorMessage}
      />

      <LiliButton
        id='submit-button'
        title={t('CHANGE_NAICS.UPDATE_NAICS_CODE')}
        onClick={onSubmit}
        isLoading={isLoading}
        disabled={errorMessage !== undefined || !isValid}
        className='w-[440px] h-[44px] mt-[32px]'
      />
    </div>
  );
};
